import { InteractiveColumnHeader } from '../../../dimensionalTable/components/ColumnHeaders';
import { capitalize } from 'lodash';
import moment from 'moment';

import {
  applyBooleanFilter,
  applyDateFilter,
  applyEmptyValuesFilter,
  applyNumberFilter,
  applyTextFilter
} from './applyFilter';
import { suppressKeyboardEvent } from '../../../../src/components/table/gridOptions';

export const gridOptions = {
  getContextMenuItems: (params) => {
    if (!params.column || params.node?.group || params.node?.rowPinned) {
      return;
    }

    const { type, valueFormatter, field } = params.column.getColDef();
    const formattedValue = valueFormatter ? valueFormatter({ value: params.value }) : params.value;

    switch (type) {
      case 'Boolean':
        return [
          {
            name:
              !formattedValue && formattedValue !== false
                ? 'Filter rows to Empty Values'
                : `Filter rows to ${capitalize(formattedValue)}`,
            action: () => {
              applyBooleanFilter(field, formattedValue);
            }
          }
        ];
      case 'Text':
        return [
          {
            name: !formattedValue ? 'Filter rows to Empty Values' : `Filter rows to ${formattedValue}`,
            action: formattedValue
              ? () => {
                  applyTextFilter(formattedValue, field);
                }
              : () => {
                  applyEmptyValuesFilter(field);
                }
          }
        ];
      case 'Percent':
      case 'Currency':
      case 'Period':
      case 'Number':
        return [
          {
            name: `Filter rows to ≤ ${formattedValue}`,
            action: () => {
              applyNumberFilter(null, parseFloat(params.value), field);
            }
          },
          {
            name: `Filter rows to = ${formattedValue}`,
            action: () => {
              applyNumberFilter(parseFloat(params.value), parseFloat(params.value), field);
            }
          },
          {
            name: `Filter rows to ≥ ${formattedValue}`,
            action: () => {
              applyNumberFilter(parseFloat(params.value), null, field);
            }
          }
        ];
      case 'Year':
        return [
          {
            name: `Filter rows to before ${formattedValue}`,
            action: () => {
              applyDateFilter(null, formattedValue.toString(), field);
            }
          },
          {
            name: `Filter rows to ${formattedValue}`,
            action: () => {
              applyDateFilter(formattedValue.toString(), formattedValue.toString(), field);
            }
          },
          {
            name: `Filter rows to after ${formattedValue}`,
            action: () => {
              applyDateFilter(formattedValue.toString(), null, field);
            }
          }
        ];
      case 'Date': {
        // in IE11, the formattedValue includes some invisible unicode characters that will break the query
        // if we pass the formattedValue to applyDateFilter().
        // To avoid this, use moment to parse the value that we use for filtering.
        const dateValue = moment(params.value).format('MM/DD/YYYY');
        return [
          {
            name: `Filter rows to before ${formattedValue}`,
            action: () => {
              applyDateFilter(null, dateValue, field);
            }
          },
          {
            name: `Filter rows to ${formattedValue}`,
            action: () => {
              applyDateFilter(dateValue, dateValue, field);
            }
          },
          {
            name: `Filter rows to after ${formattedValue}`,
            action: () => {
              applyDateFilter(dateValue, null, field);
            }
          }
        ];
      }

      default:
        return [];
    }
  },
  // show context menu manually by left clicking instead of right clicking
  onCellClicked: (params) => {
    const { data, rowPinned } = params;

    if (!data.isGroup && !rowPinned) {
      params.api.contextMenuFactory.showMenu(params.node, params.column, params.value, params.event);
    }
  },
  allowContextMenuWithControlKey: true,
  suppressContextMenu: false,
  loadingOverlayComponent: 'CustomLoadingOverlay',
  defaultColDef: {
    resizable: true,
    tooltipValueGetter: (params) => params.valueFormatted,
    tooltipComponentParams: { isDetailTable: true, extended: true },
    suppressHeaderKeyboardEvent: suppressKeyboardEvent
  },
  components: {
    agColumnHeader: InteractiveColumnHeader
  }
};
